<section class="redirect-echo">
  <h1>Redirect capture</h1>
  <p class="lead">
    Use this page as <code>redirectUrl</code> while testing locally. After a successful
    sign-in the tokens are appended to the URL hash and listed below.
  </p>

  <ng-container *ngIf="tokens(); else missingHash">
    <article class="card">
      <h2>Received tokens</h2>
      <dl>
        <div>
          <dt>idToken</dt>
          <dd><code>{{ tokens()?.idToken || '–' }}</code></dd>
        </div>
        <div>
          <dt>refreshToken</dt>
          <dd><code>{{ tokens()?.refreshToken || '–' }}</code></dd>
        </div>
        <div>
          <dt>state</dt>
          <dd><code>{{ tokens()?.state || '–' }}</code></dd>
        </div>
      </dl>
      <button type="button" (click)="copyToClipboard()">Copy JSON</button>
      <p class="feedback" *ngIf="copyFeedback()">{{ copyFeedback() }}</p>
    </article>

    <article class="card">
      <h2>Raw hash fragment</h2>
      <code class="hash">{{ rawHash() }}</code>
    </article>
  </ng-container>

  <ng-template #missingHash>
    <p class="empty">No hash parameters were detected. Append <code>#idToken=...</code> to the URL.</p>
  </ng-template>
</section>
